import { render, staticRenderFns } from "./TableRequestComponent.vue?vue&type=template&id=c4595a4a"
import script from "./TableRequestComponent.vue?vue&type=script&lang=js"
export * from "./TableRequestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports